import React from "react";
import { StyledContainer, Title, SubTitle, BodyText } from "./StyledComponents";
import Repair from "../../../assets/SVGComponents/torque-icons/Repair";

function Top({
    menuPageContent,
    rowData,
    oem,
    links,
    defaultFontFamily,
    dataAttributes,
    client,
    type,
}) {
    // Our version of device detect to tell if it's a mobile device
    const { isMobile } = window?.window?.deviceDetect?.getWindowData() || {};
    const {
        top_content_block_header,
        top_content_block_body,
        bottom_content_block_header,
        bottom_content_block_body,
    } = menuPageContent || {
        /* client content block override fields */
        top_content_block_header: rowData?.header ?? null,
        top_content_block_body: rowData?.content ?? null,
        bottom_content_block_header: rowData?.header ?? null,
        bottom_content_block_body: rowData?.content ?? null,
    };

    const title =
        type === "top_content_block"
            ? top_content_block_header
            : bottom_content_block_header;

    const body =
        type === "top_content_block"
            ? top_content_block_body
            : bottom_content_block_body;

    const icon =
        type === "top_content_block" ? (
            <Repair fill={"black"} svgIconSize={100} />
        ) : null;

    const {
        primary_button_color,
        primary_hover_button_color,
        primary_button_text_color,
        primary_hover_button_text_color,
        secondary_button_text_color,
        secondary_hover_button_text_color,
    } = oem || {
        primary_button_color: null,
        primary_hover_button_color: null,
        primary_button_text_color: null,
        primary_hover_button_text_color: null,
    };

    return (
        <StyledContainer
            className="FODTopContentContainer fod-section fod-container"
            data-testid="content_block_container"
            defaultFontFamily={defaultFontFamily}
            mobile={isMobile}
        >
            {icon}
            <Title
                className="FODTopContentTitle"
                data-testid="content_block_title"
                mobile={isMobile}
            >
                {title}
            </Title>
            {/* <SubTitle>Is Simple and Convenient</SubTitle> */}
            <BodyText
                className="FODTopContentBody"
                data-testid="content_block_body"
                textColor={primary_button_color}
                textHoverColor={primary_hover_button_color}
                dangerouslySetInnerHTML={{ __html: body }}
                mobile={isMobile}
            />
        </StyledContainer>
    );
}

export default Top;
